import React from "react";
import "./style.css";

export const Home = () => {
  return (
    <div className="home">
      <div className="div">
        <div className="rectangle" />
        <img className="IMAGE" alt="Image" src="static/img/image.png" />
        <div className="rectangle-2" />
        <div className="rectangle-3" />
        <img className="frame" alt="Frame" src="static/img/image-8.png" />
        <div className="rectangle-4" />
        <img className="img" alt="Image" src="static/img/image-1.png" />
        <img className="IMAGE-2" alt="Image" src="static/img/image-8.png" />
        <div className="rectangle-5" />
        <div className="rectangle-6" />
        <div className="rectangle-7" />
        <img className="IMAGE-3" alt="Image" src="static/img/image-8.png" />
        <img className="IMAGE-4" alt="Image" src="static/img/image-8.png" />
        <div className="rectangle-8" />
        <div className="rectangle-9" />
        <div className="rectangle-10" />
        <img className="IMAGE-5" alt="Image" src="static/img/image-8.png" />
        <img className="IMAGE-6" alt="Image" src="static/img/image-8.png" />
        <div className="rectangle-11" />
        <div className="rectangle-12" />
        <div className="rectangle-13" />
        <img className="IMAGE-7" alt="Image" src="static/img/image-8.png" />
        <img className="IMAGE-8" alt="Image" src="static/img/image-8.png" />
        <div className="rectangle-14" />
        <div className="rectangle-15" />
        <div className="rectangle-16" />
        <img className="IMAGE-9" alt="Image" src="static/img/image-9.png" />
        <img className="IMAGE-10" alt="Image" src="static/img/image-10.png" />
        <div className="rectangle-17" />
        <div className="rectangle-18" />
        <div className="rectangle-19" />
        <img className="IMAGE-11" alt="Image" src="static/img/image-11.png" />
        <img className="IMAGE-12" alt="Image" src="static/img/image-12.png" />
        <div className="rectangle-20" />
        <div className="rectangle-21" />
        <div className="rectangle-22" />
        <img className="IMAGE-13" alt="Image" src="static/img/image-13.png" />
        <img className="IMAGE-14" alt="Image" src="static/img/image-14.png" />
        <div className="rectangle-23" />
        <div className="rectangle-24" />
        <div className="rectangle-25" />
        <img className="IMAGE-15" alt="Image" src="static/img/image-15.png" />
        <img className="IMAGE-16" alt="Image" src="static/img/image-16.png" />
        <div className="rectangle-26" />
        <div className="rectangle-27" />
        <div className="rectangle-28" />
        <img className="IMAGE-17" alt="Image" src="static/img/image-17.png" />
        <img className="IMAGE-18" alt="Image" src="static/img/image-18.png" />
        <div className="rectangle-29" />
        <div className="rectangle-30" />
        <div className="rectangle-31" />
        <div className="rectangle-32" />
        <img className="IMAGE-19" alt="Image" src="static/img/image-19.png" />
        <img className="IMAGE-20" alt="Image" src="static/img/image-20.png" />
        <div className="rectangle-33" />
        <div className="rectangle-34" />
        <div className="rectangle-35" />
        <img className="IMAGE-21" alt="Image" src="static/img/image-21.png" />
        <img className="IMAGE-22" alt="Image" src="static/img/image-22.png" />
        <div className="rectangle-36" />
        <div className="rectangle-37" />
        <div className="rectangle-38" />
        <img className="IMAGE-23" alt="Image" src="static/img/image-23.png" />
        <img className="IMAGE-24" alt="Image" src="static/img/image-24.png" />
        <div className="rectangle-39" />
        <div className="rectangle-40" />
        <div className="rectangle-41" />
        <img className="IMAGE-25" alt="Image" src="static/img/image-25.png" />
        <img className="IMAGE-26" alt="Image" src="static/img/image-26.png" />
        <div className="rectangle-42" />
        <div className="rectangle-43" />
        <div className="rectangle-44" />
        <img className="IMAGE-27" alt="Image" src="static/img/image-27.png" />
        <img className="IMAGE-28" alt="Image" src="static/img/image-28.png" />
        <div className="rectangle-45" />
        <div className="rectangle-46" />
        <div className="rectangle-47" />
        <div className="rectangle-48" />
        <img className="IMAGE-29" alt="Image" src="static/img/image-29.png" />
        <img className="IMAGE-30" alt="Image" src="static/img/image-30.png" />
        <div className="rectangle-49" />
        <div className="rectangle-50" />
        <div className="rectangle-51" />
        <img className="IMAGE-31" alt="Image" src="static/img/image-31.png" />
        <img className="IMAGE-32" alt="Image" src="static/img/image-32.png" />
        <div className="rectangle-52" />
        <div className="rectangle-53" />
        <div className="rectangle-54" />
        <img className="IMAGE-33" alt="Image" src="static/img/image-33.png" />
        <img className="IMAGE-34" alt="Image" src="static/img/image-34.png" />
        <div className="rectangle-55" />
        <div className="rectangle-56" />
        <div className="rectangle-57" />
        <img className="IMAGE-35" alt="Image" src="static/img/image-35.png" />
        <img className="IMAGE-36" alt="Image" src="static/img/image-36.png" />
        <div className="rectangle-58" />
        <div className="rectangle-59" />
        <div className="rectangle-60" />
        <div className="rectangle-61" />
        <img className="IMAGE-37" alt="Image" src="static/img/image-37.png" />
        <img className="IMAGE-38" alt="Image" src="static/img/image-38.png" />
        <div className="rectangle-62" />
        <div className="rectangle-63" />
        <div className="rectangle-64" />
        <img className="IMAGE-39" alt="Image" src="static/img/image-39.png" />
        <img className="IMAGE-40" alt="Image" src="static/img/image-40.png" />
        <div className="rectangle-65" />
        <div className="rectangle-66" />
        <div className="rectangle-67" />
        <img className="IMAGE-41" alt="Image" src="static/img/image-41.png" />
        <img className="IMAGE-42" alt="Image" src="static/img/image-42.png" />
        <div className="rectangle-68" />
        <div className="rectangle-69" />
        <div className="rectangle-70" />
        <img className="IMAGE-43" alt="Image" src="static/img/image-43.png" />
        <img className="IMAGE-44" alt="Image" src="static/img/image-44.png" />
        <div className="rectangle-71" />
        <div className="rectangle-72" />
        <div className="rectangle-73" />
        <img className="IMAGE-45" alt="Image" src="static/img/image-45.png" />
        <img className="IMAGE-46" alt="Image" src="static/img/image-46.png" />
        <div className="rectangle-74" />
        <div className="rectangle-75" />
        <div className="rectangle-76" />
        <img className="IMAGE-47" alt="Image" src="static/img/image-47.png" />
        <img className="IMAGE-48" alt="Image" src="static/img/image-48.png" />
        <div className="rectangle-77" />
        <div className="rectangle-78" />
        <div className="rectangle-79" />
        <img className="IMAGE-49" alt="Image" src="static/img/image-49.png" />
        <img className="IMAGE-50" alt="Image" src="static/img/image-50.png" />
        <div className="rectangle-80" />
        <div className="rectangle-81" />
        <div className="rectangle-82" />
        <div className="rectangle-83" />
        <img className="IMAGE-51" alt="Image" src="static/img/image-51.png" />
        <img className="IMAGE-52" alt="Image" src="static/img/image-52.png" />
        <div className="rectangle-84" />
        <div className="rectangle-85" />
        <div className="rectangle-86" />
        <img className="IMAGE-53" alt="Image" src="static/img/image-53.png" />
        <img className="IMAGE-54" alt="Image" src="static/img/image-54.png" />
        <div className="rectangle-87" />
        <div className="rectangle-88" />
        <div className="rectangle-89" />
        <img className="IMAGE-55" alt="Image" src="static/img/image-55.png" />
        <img className="IMAGE-56" alt="Image" src="static/img/image-56.png" />
        <div className="rectangle-90" />
        <div className="rectangle-91" />
        <div className="rectangle-92" />
        <img className="IMAGE-57" alt="Image" src="static/img/image-57.png" />
        <img className="IMAGE-58" alt="Image" src="static/img/image-58.png" />
        <div className="rectangle-93" />
        <div className="rectangle-94" />
        <div className="rectangle-95" />
        <img className="IMAGE-59" alt="Image" src="static/img/image-59.png" />
        <img className="IMAGE-60" alt="Image" src="static/img/image-60.png" />
        <div className="rectangle-96" />
        <div className="rectangle-97" />
        <div className="rectangle-98" />
        <img className="IMAGE-61" alt="Image" src="static/img/image-61.png" />
        <img className="IMAGE-62" alt="Image" src="static/img/image-62.png" />
        <div className="rectangle-99" />
        <div className="rectangle-100" />
        <div className="rectangle-101" />
        <img className="IMAGE-63" alt="Image" src="static/img/image-63.png" />
        <img className="IMAGE-64" alt="Image" src="static/img/image-64.png" />
        <div className="rectangle-102" />
        <div className="rectangle-103" />
        <div className="rectangle-104" />
        <img className="IMAGE-65" alt="Image" src="static/img/image-65.png" />
        <img className="IMAGE-66" alt="Image" src="static/img/image-66.png" />
        <div className="rectangle-105" />
        <div className="rectangle-106" />
        <div className="rectangle-107" />
        <div className="rectangle-108" />
        <img className="IMAGE-67" alt="Image" src="static/img/image-67.png" />
        <img className="IMAGE-68" alt="Image" src="static/img/image-68.png" />
        <div className="rectangle-109" />
        <div className="rectangle-110" />
        <div className="rectangle-111" />
        <div className="text-wrapper">Featured</div>
        <div className="text-wrapper-2">Technology</div>
        <div className="text-wrapper-3">Productivity</div>
        <div className="text-wrapper-4">Finance</div>
        <div className="text-wrapper-5">Shopping</div>
        <div className="text-wrapper-6">Travel</div>
        <div className="text-wrapper-7">Follow us on Twitter</div>
        <div className="text-wrapper-8">@FFStudentsorg</div>
        <p className="p">for weekly updates on new deals!</p>
        <div className="text-wrapper-9">Coming Soon</div>
        <h1 className="h-1">Students, big savings are coming.</h1>
        <p className="we-re-launching-a">
          We&#39;re launching a new platform! Sign up to our newsletter for early access to exclusive student deals.
        </p>
        <div className="text-wrapper-10">Sign up now</div>
        <div className="text-wrapper-11">Amazon Prime Student</div>
        <p className="text-wrapper-12">Free For 6 Months • Worldwide</p>
        <div className="text-wrapper-13">Professional Developer Software</div>
        <p className="text-wrapper-14">Free For 12 Months • Worldwide</p>
        <div className="text-wrapper-15">Student Developer Pack</div>
        <p className="text-wrapper-16">Free For Current Students • Worldwide</p>
        <p className="text-wrapper-17">Free .me and Discounted Domain Names</p>
        <p className="text-wrapper-18">Free For 12 Months • Worldwide</p>
        <div className="text-wrapper-19">Student Store Discounts</div>
        <p className="text-wrapper-20">Discounted For Current Students • Worldwide</p>
        <div className="text-wrapper-21">Web Hosting (90% Discount)</div>
        <p className="text-wrapper-22">Discounted For 6 Months • UK Only</p>
        <div className="text-wrapper-23">Design and Modelling Software</div>
        <p className="text-wrapper-24">Free For 36 Months • Worldwide</p>
        <div className="text-wrapper-25">AWS Educate Program</div>
        <p className="text-wrapper-26">Free For 12 Months • Worldwide</p>
        <div className="text-wrapper-27">Education Program (15% Discount)</div>
        <p className="discounted-for">Discounted For Current Students • EU &amp; USA Only</p>
        <div className="text-wrapper-28">Office 365 Software</div>
        <p className="text-wrapper-29">Free For Current Students • Worldwide</p>
        <div className="text-wrapper-30">Project Management Software</div>
        <p className="text-wrapper-31">Free For Current Students • Worldwide</p>
        <div className="text-wrapper-32">Flowchart Software</div>
        <p className="text-wrapper-33">Free For Current Students • Worldwide</p>
        <div className="text-wrapper-34">Cloud Computing Credit</div>
        <p className="text-wrapper-35">Free For Current Students • Worldwide</p>
        <div className="text-wrapper-36">Education Pricing Program</div>
        <p className="text-wrapper-37">Discounted For Current Students • Worldwide</p>
        <div className="text-wrapper-38">Secure VPN (81% Discount)</div>
        <p className="text-wrapper-39">Discounted for 24 Months • Worldwide</p>
        <div className="text-wrapper-40">All-In-One Workspace Software</div>
        <p className="text-wrapper-41">Free For 12 Months • Worldwide</p>
        <div className="text-wrapper-42">Creative Cloud (60% Discount)</div>
        <p className="text-wrapper-43">Discounted for 12 Months • Worldwide</p>
        <div className="text-wrapper-44">NEW DEAL!</div>
        <p className="text-wrapper-45">Premium for Students (50% Discount)</p>
        <p className="text-wrapper-46">Discounted For Current Students • Worldwide</p>
        <div className="text-wrapper-47">Business Analytics Software</div>
        <p className="text-wrapper-48">Free For 12 Months • Worldwide</p>
        <div className="text-wrapper-49">Design Software (50% Discount)</div>
        <p className="text-wrapper-50">Free For Current Students • Worldwide</p>
        <div className="text-wrapper-51">Website Builder (50% Discount)</div>
        <p className="text-wrapper-52">Discounted For 12 Months • Worldwide</p>
        <div className="text-wrapper-53">Project Management Software</div>
        <p className="text-wrapper-54">Free For 6 Months • Worldwide</p>
        <div className="text-wrapper-55">Password Manager Premium Plan</div>
        <p className="text-wrapper-56">Free For 6 Months • Worldwide</p>
        <div className="text-wrapper-57">Software Development Tools</div>
        <p className="text-wrapper-58">Free For Current Students • Worldwide</p>
        <div className="text-wrapper-59">NEW DEAL!</div>
        <div className="text-wrapper-60">Education Deals (20% Discount)</div>
        <p className="text-wrapper-61">Discounted For Current Students • Worldwide</p>
        <div className="text-wrapper-62">25% Student Discount</div>
        <p className="text-wrapper-63">Discounted For Current Students • UK Only</p>
        <div className="text-wrapper-64">Digital Design Software</div>
        <p className="text-wrapper-65">Free For Current Students • Worldwide</p>
        <div className="text-wrapper-66">Desktop Git Client</div>
        <p className="text-wrapper-67">Free For Current Students • Worldwide</p>
        <div className="text-wrapper-68">Product Design Software</div>
        <p className="text-wrapper-69">Free For Current Students • Worldwide</p>
        <div className="text-wrapper-70">Wireframing Software</div>
        <p className="text-wrapper-71">Free For 12 Months • Worldwide</p>
        <div className="text-wrapper-72">Exclusive Flight Discounts</div>
        <p className="text-wrapper-73">Discounted For Current Students • Worldwide</p>
        <div className="text-wrapper-74">Personal Budgeting Software</div>
        <p className="text-wrapper-75">Free For Current Students • Worldwide</p>
        <div className="text-wrapper-76">NEW DEAL!</div>
        <div className="text-wrapper-77">10% Student Discount</div>
        <p className="text-wrapper-78">Discounted For Current Students • Worldwide</p>
        <p className="text-wrapper-79">
          This site contains affiliate links to products. We may receive a commission for purchases made through these
          links.
        </p>
        <div className="text-wrapper-80">© Copyright 2023.</div>
        <div className="text-wrapper-81">Terms and Conditions</div>
        <div className="text-wrapper-82">Privacy Policy</div>
        <div className="rectangle-112" />
        <div className="rectangle-113" />
        <img className="IMAGE-69" alt="Image" src="static/img/image-69.png" />
        <img className="IMAGE-70" alt="Image" src="static/img/image-70.png" />
        <div className="rectangle-114" />
        <div className="rectangle-115" />
        <div className="rectangle-116" />
        <img className="IMAGE-71" alt="Image" src="static/img/image-71.png" />
        <img className="IMAGE-72" alt="Image" src="static/img/image-72.png" />
        <div className="rectangle-117" />
        <div className="rectangle-118" />
        <div className="rectangle-119" />
        <img className="IMAGE-73" alt="Image" src="static/img/image-73.png" />
        <img className="IMAGE-74" alt="Image" src="static/img/image-74.png" />
        <div className="rectangle-120" />
        <div className="text-wrapper-83">Amazon Prime Student</div>
        <p className="text-wrapper-84">Free For 6 Months • Worldwide</p>
        <div className="text-wrapper-85">Professional Developer Software</div>
        <p className="text-wrapper-86">Free For 12 Months • Worldwide</p>
        <div className="text-wrapper-87">Student Developer Pack</div>
        <p className="text-wrapper-88">Free For Current Students • Worldwide</p>
        <div className="rectangle-121" />
        <div className="rectangle-122" />
        <img className="frame-2" alt="Frame" src="static/img/frame-1.svg" />
        <div className="text-wrapper-89">Featured</div>
        <div className="text-wrapper-90">Technology</div>
        <div className="flex-container">
          <div className="text">
            <span className="span">
              Student
              <br />
            </span>
          </div>
          <div className="text-2">
            <span className="span">Discount</span>
            <span className="text-wrapper-91">.xyz</span>
          </div>
        </div>
        <div className="text-wrapper-92">Productivity</div>
        <div className="text-wrapper-93">Finance</div>
        <div className="text-wrapper-94">Shopping</div>
        <div className="text-wrapper-95">Travel</div>
        <div className="text-wrapper-96">Follow us on Twitter</div>
        <div className="text-wrapper-97">@EduDiscount</div>
        <p className="text-wrapper-98">for weekly updates on new deals!</p>
      </div>
    </div>
  );
};
